// ============================================================
//  Cosmo's Learning Adventure — Color Palette
// ============================================================
export const C = {
  // Deep space background
  deepSpace:      0x000010,
  cosmicDark:     0x0d0221,
  cosmicMid:      0x1a0a2e,
  cosmicLight:    0x2d1a4a,

  // Nebula accents
  nebulaPurple:   0x7b2fff,
  nebulaBlue:     0x2f6fff,
  nebulaCyan:     0x00e5ff,
  nebulaPink:     0xff4dbd,
  nebulaTeal:     0x00e5cc,

  // Cosmo palette
  cosmoPurple:    0x8b3fff,
  cosmoBlue:      0x4fc3f7,
  cosmoBodyTop:   0x6a1fe0,
  cosmoBodyBot:   0x1a6fe0,
  cosmoGlow:      0xaa5fff,
  cosmoGoldStar:  0xffd700,
  cosmoGold:      0xffb300,

  // World: Number Kingdom
  nkGold:         0xffa500,
  nkAmber:        0xff8c00,
  nkOrange:       0xff6b00,
  nkCrystal:      0xff9a00,
  nkCastle:       0x4a3080,

  // World: Story Forest
  sfGreen:        0x2da84e,
  sfForest:       0x1a5c2a,
  sfTeal:         0x00c9a7,

  // World: Discovery Lab
  dlCyan:         0x00bcd4,
  dlBlue:         0x0288d1,
  dlWhite:        0xe0f7fa,

  // UI chrome
  panelDark:      0x120830,
  panelMid:       0x1e1040,
  panelBorder:    0x3d2060,
  gold:           0xffd700,
  orange:         0xff8c00,
  white:          0xffffff,
  cream:          0xfff8e1,
  textGold:       0xffd700,
  textCyan:       0x80ffff,

  // Game-feel feedback
  correct:        0x00e676,
  incorrect:      0xff5252,
  hint:           0xffeb3b,

  // Bridge segments
  bridgeDark:     0x1a0a2e,
  bridgeLit:      0xff8c00,
  bridgeGlow:     0xffcc00,
};

// Hex string versions for CSS/Phaser Text
export const CS = {
  white:   '#ffffff',
  gold:    '#ffd700',
  orange:  '#ff8c00',
  cyan:    '#00e5ff',
  purple:  '#9b4dff',
  correct: '#00e676',
  wrong:   '#ff5252',
  hint:    '#ffeb3b',
  panel:   '#1e1040',
  cream:   '#fff8e1',
};
